// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__12xwk","form":"styles_form__1dsjF"};